<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
    <DataSectionItem
      title="Profissionais"
      :value="homeStore.data.professionals_count"
      :icon-background="getColor('info')"
      icon-color="white"
    >
      <template #icon>
        <VaIcon name="business_center" size="large" />
      </template>
    </DataSectionItem>
    <DataSectionItem
      title="Clientes"
      :value="homeStore.data.customers_count"
      :icon-background="getColor('warning')"
      icon-color="white"
    >
      <template #icon>
        <VaIcon name="group" size="large" />
      </template>
    </DataSectionItem>
    <DataSectionItem
      title="Produtos"
      :value="homeStore.data.products_count"
      :icon-background="getColor('success')"
      icon-color="white"
    >
      <template #icon>
        <VaIcon name="inventory" size="large" />
      </template>
    </DataSectionItem>
  </div>
</template>

<script lang="ts" setup>
import { useColors, VaIcon } from 'vuestic-ui'
import DataSectionItem from './DataSectionItem.vue'
import { useHomeStore } from '../../../stores/home'

const homeStore: any = useHomeStore()

const { getColor } = useColors()
</script>
